import React, { Component } from 'react';
import { connect } from 'react-redux';

import { formatNewLines } from '../../util';
import { getIcon } from '../../util/icons';

class TrackGoalModal extends Component{

  componentWillMount(){
    this.updateValue = this.updateValue.bind(this);
    this.updateMeta = this.updateMeta.bind(this);
  }

  updateValue(newValue){
    if(!this.props.editing){
      return;
    }

    const goalId = this.props.goal.id;
    const currentValue = this.props.goal.goalValue;

    this.props.updateGoalValue(
      goalId,
      {
        ...currentValue,
        ...newValue
      }
    );
  }
  updateMeta(newMeta){
    if(!this.props.editing){
      return;
    }

    const goalId = this.props.goal.id;

    this.props.updateGoalMeta(
      goalId,
      newMeta
    );
  }

  render(){

    const { goal, editing } = this.props;

    //console.log('goal updated: ', goal);

    const goalValue = goal.goalValue;
    const goalMeta = goal.goalMeta;

    const goalId = goal.id;

    const smartGoal = (goalMeta || {}).smartGoal || 'No goal created.';
    const actionPlan = (goalMeta || {}).actionPlan || 'No aciton plan created.';

    const practiced = (goalValue || {}).practiced || false;
    const applied = (goalValue || {}).applied || false;
    const improved = (goalValue || {}).improved || false;

    const practicedHow = (goalMeta || {}).practicedHow || '';
    const appliedHow = (goalMeta || {}).appliedHow || '';
    const improvedHow = (goalMeta || {}).improvedHow || '';

    if(!this.props.visible){
      return null;
    }

    return (
      <div className="modal track-goal">
        <div className="modal-container">
          <div className="close-icon" onClick={this.props.hide}>X</div>
          <div className="modal-content">
            <div className="goal-info">
              <h2>{goal.name}</h2>
              <p>{goal.description}</p>
              <h3>Goal</h3>
              <p dangerouslySetInnerHTML={{__html: formatNewLines(smartGoal)}}></p>
              <h3>Action plan</h3>
              <p dangerouslySetInnerHTML={{__html: formatNewLines(actionPlan)}}></p>
            </div>
            <div className={'track-goal' + (editing ? ' editable' : '')}>
              <div className="checkbox-container">
                <div className="checkbox-description">Did you work on it?</div>
                <div onClick={() => { this.updateValue({ practiced: !practiced }); }} className={'checkbox' + (practiced ? ' checked' : '')}>{getIcon('check')}</div>
                {practiced &&
                  <textarea disabled={!editing} value={practicedHow} onChange={e => { this.updateMeta({ practicedHow: e.target.value }); }} placeholder="What did you do?"></textarea>
                }
              </div>
              <div className="checkbox-container">
                <div className="checkbox-description">Did you apply it?</div>
                <div onClick={() => { this.updateValue({ applied: !applied }); }} className={'checkbox' + (applied ? ' checked' : '')}>{getIcon('check')}</div>
                {applied &&
                  <textarea disabled={!editing} value={appliedHow} onChange={e => { this.updateMeta({ appliedHow: e.target.value }); }} placeholder="When?"></textarea>
                }
              </div>
              <div className="checkbox-container">
                <div className="checkbox-description">Did you improve?</div>
                <div onClick={() => { this.updateValue({ improved: !improved }); }} className={'checkbox' + (improved ? ' checked' : '')}>{getIcon('check')}</div>
                {improved &&
                  <textarea disabled={!editing} value={improvedHow} onChange={e => { this.updateMeta({ improvedHow: e.target.value }); }} placeholder="How?"></textarea>
                }
              </div>
            </div>
          </div>
          <div className="modal-actions">
            <button onClick={this.props.hide} className="button primary">Done</button>
          </div>
        </div>
      </div>
    )
  }
}

export default TrackGoalModal;



// WEBPACK FOOTER //
// ./src/components/modals/trackGoal.js